import React from 'react'
import AppRoutes from 'sites/app/Routes'

export default () => {
  return <AppRoutes />
}
